import { Component } from "react";

class ModalLauncher extends Component {
  UNSAFE_componentWillMount() {
    this.props.launchModal(this.props.modalType, this.props);
  }

  render() {
    return null;
  }
}

export default ModalLauncher;
